'use es6';

import PropTypes from 'prop-types';
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
import { EDGE_TOOLBAR_HEIGHT, PINNED_TOOLBAR_HEIGHT } from './constants';

// Quite hacky for now, but grippies will change soon anyway (I believe)
import { jsx as _jsx } from "react/jsx-runtime";
const topPosition = toolbarHeight => {
  if (toolbarHeight === EDGE_TOOLBAR_HEIGHT) {
    return 7;
  } else if (toolbarHeight === PINNED_TOOLBAR_HEIGHT) {
    return 8;
  }
  throw new Error('Unknown toolbar height');
};
const ToolbarGrippies = ({
  useDark,
  toolbarHeight
}) => /*#__PURE__*/_jsx(UIDragHandle, {
  use: useDark ? 'on-dark' : 'default',
  size: "default",
  style: {
    position: 'absolute',
    margin: 0,
    padding: 0,
    height: 11,
    left: 6,
    top: topPosition(toolbarHeight),
    backgroundPosition: '0px top'
  }
});
ToolbarGrippies.propTypes = {
  useDark: PropTypes.bool.isRequired,
  toolbarHeight: PropTypes.number.isRequired
};
export default ToolbarGrippies;